module.exports = __webpack_public_path__ + "img/normal-banner.87afb82d.png";